import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import LinkoPayInput from './LinkoPayInput';

import WhitePencelIcon from '../../image/WhitePencel.svg';

export default function LinkoPayBox(props) {
  const { 
    data,
    businessRegistrationNumber,
    setBusinessRegistrationNumber,
    representativeName,
    setRepresentativeName,
    email,
    setEmail,
    bankName,
    setBankName,
    accountNumber,
    setAccountNumber,
    settleCycle,
    setSettleCycle,
    settleCycleUnit,
    setSettleCycleUnit,
    onClickSettleSubmit
  } = props;

  const { t } = useLanguage();

  // 버튼 텍스트 결정 //
  function decideButtonText() {
    if (data === undefined) return t('myStoreSetting.linkoPay.reviewRequest');
    else if (data.sellerStatus === undefined
      || data.sellerStatus === 'APPROVAL_REQUIRED'
      || data.sellerStatus === 'KYC_REQUIRED') return t('myStoreSetting.linkoPay.reviewing');
    else if (data.sellerStatus === 'PARTIALLY_APPROVED'
      || data.sellerStatus === 'APPROVED') return t('myStoreSetting.linkoPay.activated');
  }

  // 버튼 색상 결정 //
  function decideButtonBackgroundColor() {
    if (data === undefined) return '#CBCBCB';
    else if (data.sellerStatus === 'PARTIALLY_APPROVED'
      || data.sellerStatus === 'APPROVED') return '#53B38F';
    else return '#CBCBCB';
  }

  // 정산 주기 계산 //
  function decideSettlementCycle() {
    if (settleCycleUnit === 'month') return settleCycle * 30;
    else if (settleCycleUnit === 'week') return settleCycle * 7;
    else return settleCycle;
  }

  function onClickModifyButton() {
    if (data === undefined) onClickSettleSubmit();
  }

  return (
    <TopLevelWrapper>
      <TitleWrapper>
        <TitleBox backgroundColor='#53B38F'>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='default'>{t('myStoreSetting.linkoPay.title')}</Text>
        </TitleBox>
        <ModifyButton width={data === undefined ? 105 : 82} backgroundColor={decideButtonBackgroundColor()} onClick={onClickModifyButton}>
          { data === undefined && <PencelImage src={WhitePencelIcon}/> }
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='pointer'>{decideButtonText()}</Text>
        </ModifyButton>
      </TitleWrapper>
      <InfoView>
        <InfoWrapper>
          <LayerWrapper topMargin={0}>
            <LinkoPayInput
              width={124}
              disabled={data !== undefined}
              column={t('myStoreSetting.linkoPay.businessNumber')}
              value={businessRegistrationNumber}
              setValue={setBusinessRegistrationNumber}
              placeholder={t('myStoreSetting.linkoPay.businessNumber')}/>
            <LinkoPayInput
              width={162}
              disabled={data !== undefined}
              column={t('myStoreSetting.linkoPay.representativeName')}
              value={representativeName}
              setValue={setRepresentativeName}
              placeholder={t('myStoreSetting.linkoPay.representativeName')}/>
            <LinkoPayInput
              width={162}
              disabled={data !== undefined}
              column={t('myStoreSetting.linkoPay.email')}
              value={email}
              setValue={setEmail}
              placeholder={t('myStoreSetting.linkoPay.email')}/>
            <LinkoPayInput
              width={137}
              disabled={data !== undefined}
              column={t('myStoreSetting.linkoPay.settlementBank')}
              value={bankName}
              setValue={setBankName}
              placeholder={t('myStoreSetting.linkoPay.settlementBank')}/>
            <LinkoPayInput
              width={190}
              disabled={data !== undefined}
              column={t('myStoreSetting.linkoPay.settlementAccount')}
              value={accountNumber}
              setValue={setAccountNumber}
              placeholder={t('myStoreSetting.linkoPay.settlementAccount')}/>
            <SettleCycleWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' hover='default'>{t('myStoreSetting.linkoPay.settlementCycle')}</Text>
              <SettleCycleInfoWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='default'>{t('myStoreSetting.linkoPay.paymentDate')}</Text>
                <SettleCycleInputView>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='default'>{decideSettlementCycle()}</Text>
                </SettleCycleInputView>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' hover='default'>{t('myStoreSetting.linkoPay.days')}</Text>
              </SettleCycleInfoWrapper>
            </SettleCycleWrapper>
          </LayerWrapper>
        </InfoWrapper>
      </InfoView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 1191px;
  width: 100%;
  height: 99px;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  background-color: #FFFFFF;
`;

const TitleBox = styled.p`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 20px;
  margin: 0 0 0 0;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  background-color: ${props => props.backgroundColor};
`;

const ModifyButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // width: 82px;
  width: ${props => props.width}px;
  height: 24px;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  gap: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1135px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-top: ${props => props.topMargin}px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const PencelImage = styled.img`
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
`;

const SettleCycleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 8px;
`;

const SettleCycleInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const SettleCycleInputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 58px;
  height: 30px;

  border-radius: 8px;
  border: 1px solid #DFDFDF;
  background-color: #FFFFFF;
`;